import React from 'react';
import { ResponsivePie } from '@nivo/pie' 

export default function Pie2Graph({data}) {

  /*const data = [
    {
      "id": "Até 30 anos",
      "label": "Facebook",
      "value": 520
    },
    {
      "id": "Instagram",
      "label": "Instagram",
      "value": 131
    },
    {
      "id": "Site",
      "label": "Site",
      "value": 45
    }
  ];*/

return(
    <ResponsivePie
        data={data}
        margin={{ top: 0, right: 10, bottom: 70, left: 10 }}
        colors={{ scheme: 'pastel1' }}
        borderColor={{ from: 'color', modifiers: [ [ 'opacity', '1.2' ] ] }}
        enableRadialLabels={false}
        radialLabelsSkipAngle={10}
        radialLabelsTextXOffset={6}
        radialLabelsTextColor="#333333"
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={16}
        radialLabelsLinkHorizontalLength={24}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: 'color' }}
        slicesLabelsSkipAngle={10}
        slicesLabelsTextColor="#333333"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        legends={[
            {
                anchor: 'bottom-left',
                direction: 'column',
                justify: false,
                translateX: 20,
                translateY: 60,
                itemsSpacing: 1,
                itemDirection: 'left-to-right',
                itemWidth: 100,
                itemHeight: 15,
                itemOpacity: 0.75,
                symbolSize: 9,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
    />
)};